<template>
    <v-container grid-list-lg style="max-width: 1240px" class="py-0 px-0 user-contact-data">
        <v-layout v-if="!short">
            <v-flex pt-0 pb-2>
                <h2 :class="b2c ? 'b2c-title' : '' ">{{title}}</h2>
            </v-flex>
        </v-layout>

        <v-layout v-if="short">
            <v-flex pt-0 pb-0>
                <h2 :class="b2c ? 'pb-0 b2c-title' : 'pb-0' ">{{shortTitle}}</h2>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 md6
                v-show="!hidePhone"
                :class="[this.short ? 'lg5' : 'lg4']" py-0
            >
                <v-text-field
                        v-model="maskedPhone"
                        :rules="phoneRules"
                        v-mask="'+7 ### ### ## ##'"
                        :label="short ? 'Телефон (для входа в личный кабинет)' : phoneInput"
                        validate-on-blur
                        :hint="attentionPhoneText"
                        required
                        clearable
                ></v-text-field>
                <span v-if="short" style="font-size: 17px;">На него придет пароль от личного кабинета.<br>
                    Чтобы вы не потеряли данные и не запоминали пароли.</span>
                <v-flex  v-if="!short && b2c" :class="[b2c ? 'padding-top-small' : '']">
                    <span :class="[b2c ? 'contacts-label-b2c' : 'contacts-label']">
                        <span v-html="attention"></span>
                    </span>
                </v-flex>
            </v-flex>

            <v-flex v-if="!short" xs12 md6 lg4 pt-0>
                <v-text-field
                        @keydown.space.prevent
                        v-model="value.email"
                        :rules="emailRules"
                        label="E-mail (на него придет полис)"
                        validate-on-blur
                        required
                        clearable
                ></v-text-field>

                <v-flex  v-if="!short && b2c" :class="[b2c ? 'padding-top-small' : '']">
                    <span :class="[b2c ? 'contacts-label-b2c' : 'contacts-label']">
                        ВАЖНО! Проверьте правильность e-mail, на него придет электронный полис ОСАГО
                    </span>
                </v-flex>
            </v-flex>
            <v-flex  v-if="!short && !b2c" xs12 md6 offset-md6 offset-lg0 lg4 pt-0>
                <span :class="[b2c ? 'contacts-label-b2c' : 'contacts-label']">
                    <span v-html="attention"></span>
                </span>
            </v-flex>
        </v-layout>
        <v-layout v-if="useTempPhone" row wrap>
            <v-flex xs12 md6>
                <v-checkbox
                    label="Использовать временный номер телефона"
                    v-model="value.useTempNumber"
                    class="mt-0"
                    @change="useTempPhoneChanged"
                />
                <br v-if="value.tempPhone">
                <span v-if="value.tempPhone">Телефон: +{{value.tempPhone}}</span>
                <br v-if="value.phoneCode">
                <span v-if="value.phoneCode">Смс-код: {{value.phoneCode}}</span>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "User",
        props: ['value', 'short', 'titleText', 'phoneInputText', 'attentionText', 'attentionPhoneText', 'b2c', 'hidePhone', 'useTempPhone'],

        data: () => ({
            maskedPhone: '',
            emailRules: [
                v => !!v || 'Обязательное поле',
                v => !(/[А-ЯЁа-яё\s]/i.test(v)) || 'E-mail не должен содержать кириллицу и пробелы',
                v => !(/[_.-]{2}/.test(v)) || 'Email не должен содержать идущие друг за другом знак подчеркивания, точку и минус',
                v => /^[A-Za-z0-9@._-]*$/.test(v) || 'Допустимы только латиница, цифры, "@", "-", "_", "."',
                v => /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,24}\b/.test(v) || 'Неверный формат',
                v => !!v && v.length <= 35 || 'E-mail не должен превышать 35 символов',
            ],
            phoneRules: [
                v => !!v || 'Обязательное поле',
                v => /^\+7 \d{3} \d{3} \d{2} \d{2}$/.test(v) || 'Неверный формат'
            ],
            title: "Контакты для получения полиса",
            shortTitle: "Контакты для получения полиса",
            phoneInput: "Телефон страхователя",
            attention: "<b>ВАЖНО!</b> Проверьте правильность<br>e-mail, на него придет электронный полис ОСАГО",
        }),

        created: function() {
            this.title = this.titleText ? this.titleText : this.title;
            this.shortTitle = this.titleText ? this.titleText : this.shortTitle;
            this.phoneInput = this.phoneInputText ? this.phoneInputText : this.phoneInput;
            this.attention = this.attentionText ? this.attentionText : this.attention;
            this.maskedPhone = '+' + this.value.phone;
        },

        watch: {
            maskedPhone(val) {
                const char = val.charAt(0);
                let that = this;
                if (val.length === 1 && (char === '8' || char === '7' || !/\d/.test(char))) {
                    this.$nextTick(function() {
                        that.maskedPhone = '+7 ';
                    });
                }
                this.$nextTick(function() {
                    that.value.phone = that.unmaskPhone(that.maskedPhone);
                });
            }
        },

        methods: {
            unmaskPhone(phone) {
                return phone ? phone.match(/[0-9]+/g, '').join('') : phone;
            },

            useTempPhoneChanged(val) {
                if (!val) {
                    this.value.phoneCode = null;
                }
            }
        }
    }
</script>

<style scoped>

.contacts-label {
    padding-top: 12px;
    display: inline-block;
    font-size: 16px;
    line-height: 22px;
    @media (max-width: 960px) {
        padding-bottom: 10px;
    }
}

.contacts-label-b2c {
    padding-top: 0;
    display: inline-block;
    font-size: 16px;
    line-height: 22px;
}

.padding-top-small{
    padding-top: 2px !important;
}

@media (min-width: 960px) {
    .contacts-label-b2c {
        font-size: 14px;
        line-height: 20px;
    }
}

.user-contact-data h3.b2c-title {
    font-size: 28px;
}

@media screen and (max-width: 960px){
    .user-contact-data h3.b2c-title {
        font-size: 20px;
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/components/fields/User.vue